module.exports = __webpack_public_path__ + "static/sole-1f39fa4e669a1e0059f1c6145ee17653.jpg";